import React from "react";
import { useTranslation } from "react-i18next";
import { Image } from "@imagekit/react";
import LocalizedLink from "../LocalizedLink/LocalizedLink";
import { academicYear } from "../../data/programs";

// Season announcement: title, start date, hadith and the two calls to action.
// The poster (if uploaded) is shown next to the text, never instead of the
// HTML programme rendered further down the page by <ProgramIntro />.
const PROGRAMME_ANCHOR = "programme";

const scrollToProgramme = (e) => {
  const target = document.getElementById(PROGRAMME_ANCHOR);
  if (!target) return; // let the plain anchor jump do its job
  e.preventDefault();
  target.scrollIntoView({ behavior: "smooth", block: "start" });
};

const ProgramAnnouncement = () => {
  const { t } = useTranslation("home");
  const { gregorianYear, startDate, poster } = academicYear;

  return (
    <section className="programme-announcement" id="programme-announcement">
      <div className="container">
        <div className="row align-items-center justify-content-center g-5">
          <div className={poster ? "col-lg-7 col-12" : "col-lg-9 col-12"}>
            <div className="programme-announcement__content">
              <span className="programme-announcement__kicker">
                {t("programme.announcement.kicker")}
              </span>

              <h2 className="programme-announcement__title">
                {t("programme.announcement.title", { year: gregorianYear })}
              </h2>

              <div className="programme-announcement__start">
                <i className="ti-calendar" aria-hidden="true"></i>
                <div>
                  <span className="programme-announcement__start-prefix">
                    {t("programme.announcement.startPrefix")}
                  </span>
                  <time
                    className="programme-announcement__start-date"
                    dateTime={startDate}
                  >
                    {t("programme.announcement.startDate")}
                  </time>
                </div>
              </div>

              <blockquote className="programme-announcement__quote">
                <p>{t("programme.announcement.hadith")}</p>
                <cite>{t("programme.announcement.hadithSource")}</cite>
              </blockquote>

              <div className="programme-announcement__actions">
                <a
                  href={`#${PROGRAMME_ANCHOR}`}
                  className="theme-btn"
                  onClick={scrollToProgramme}
                >
                  {t("programme.announcement.ctaProgramme")}
                </a>
                <LocalizedLink to="/contact" className="programme-btn-outline">
                  {t("programme.announcement.ctaContact")}
                </LocalizedLink>
              </div>
            </div>
          </div>

          {poster && (
            <div className="col-lg-5 col-md-8 col-12">
              <div className="programme-announcement__poster">
                <Image
                  src={poster}
                  alt={t("programme.announcement.posterAlt", {
                    year: gregorianYear,
                  })}
                  transformation={[
                    {
                      width: "800",
                      crop: "maintain_ratio",
                      focus: "auto",
                    },
                  ]}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProgramAnnouncement;
